import { createRouter, createWebHistory } from "vue-router";
import HomeView from "../views/HomeView.vue";

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
  },
  {
    path: "/about",
    name: "about",
    component: () => import("../views/AboutView.vue"),
  },
  {
    path: "/product",
    name: "product",
    component: () => import("../views/ProductView.vue"),
  },
  {
    path: "/certificate",
    name: "certificate",
    component: () => import("../views/CertificateView.vue"),
  },
  {
    path: "/contact",
    name: "contact",
    component: () => import("../views/ContectView.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});
router.beforeEach((to, from, next) => {
  // 可以在这里进行身份验证、权限检查、加载数据等
  // ...
  try {
    document.documentElement.scrollTop = 500;
    document.body.scrollTop = 500;
  } catch (e) {
    console.log(e);
  }
  // 必须调用next()来resolve这个钩子
  next();
});
export default router;
